import { Trans } from '@lingui/macro'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import DocumentCard from '@/components/ui/cards/DocumentCard'

type Document = {
  key: string
  name: string
  type: string
  src: string
}

export type HistoricalConsultationDocumentsProps = {
  documents: Document[]
  onSelectFile: (file: Document) => void
}

export function HistoricalConsultationDocuments(props: HistoricalConsultationDocumentsProps) {
  const { documents, onSelectFile } = props

  if (!documents.length) {
    return (
      <Typography>
        <Trans>No files</Trans>
      </Typography>
    )
  }

  return (
    <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 8 }}>
      {documents.map((file, index) => (
        <Grid key={index} item xs={2.5}>
          <Box onClick={() => onSelectFile(file)} sx={{ width: 'inherit' }}>
            <DocumentCard extension={file.type} primaryText={`${file.name}.${file.type}`} secondaryText="" src={file.src} sx={{ margin: '0 auto' }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
